const links = [
  { label: 'Model', href: '#model' },
  { label: 'Opportunities', href: '#opportunities' },
  { label: 'Services', href: '#services' },
  { label: 'Process', href: '#how' },
  { label: 'Contact', href: '#contact' },
];

function Footer() {
  return (
    <footer>
      <div className="footer-logo">
        TRI<span>KON</span>
      </div>

      <div className="footer-links">
        {links.map((link) => (
          <a key={link.label} href={link.href}>
            {link.label}
          </a>
        ))}
      </div>

      <div className="footer-copy">&copy; 2025 Trikon. All rights reserved.</div>
    </footer>
  );
}

export default Footer;
